<script lang="ts">
  import { slide, type TransitionConfig } from "svelte/transition";
  import type { Product } from "../../helpers/types";
  import InputContainer from "../atoms/InputContainer.svelte";
  import PriceInfo from "../molecules/PriceInfo.svelte";
  import Specification from "../molecules/Specification.svelte";
  import HourlyPriceReminder from "../molecules/HourlyPriceReminder.svelte";
  import { ProductTypeId } from "../../helpers/constants";
  interface Props {
    product: Product;
    selectedProduct: Product | undefined;
    productId: number;
    onClick: () => void;
  }

  let { product, selectedProduct = $bindable(), productId, onClick }: Props = $props();

  const slideInOut = (node: Element): TransitionConfig => slide(node, { duration: 300 });
</script>

<InputContainer
  {onClick}
  onChange={() => (selectedProduct = product)}
  checked={selectedProduct && selectedProduct.id == productId}
  name="product-selection"
  value={product.id.toString()}
>
  <div class="flex flex-row justify-between">
    <div>
      <div>
        <span class="text-H3 mr-3">{product.name}</span>
        {#if product.recommended}
          <span class="tape-Green400 text-white text-H6 hidden md:inline-block">REKOMMENDERAT</span>
        {/if}
      </div>
      {#if product.costs}
        <PriceInfo
          class="block md:hidden py-2"
          productType={product.type}
          costs={product.costs}
        />
      {/if}
      {#if product.purchaseText}
        <div class="pb-2 md:py-2 purchase-text">{@html product.purchaseText}</div>
      {/if}
    </div>
    {#if product.costs}
      <PriceInfo class="hidden md:block" productType={product.type} costs={product.costs} />
    {/if}
  </div>
  <Specification defaultOpen={false} {product} />
  {#if selectedProduct && productId && selectedProduct.id === productId && product.typeId === ProductTypeId.KVARTSPRIS}
    <div class="mt-4" in:slideInOut out:slideInOut>
      <HourlyPriceReminder />
    </div>
  {/if}
</InputContainer>
